import { useQuery } from "@tanstack/react-query";
import { fetchWithToken } from "../../utils/fetchToken";
import { ContactData } from "@components/types/ContactData";

interface UserDetailsResponse {
  isLoggedInUser: boolean;
  contactData: ContactData | null;
}

const fetchUserDetails = async (id: string): Promise<UserDetailsResponse> => {
  const CRM_CONTACT_ID = id;
  if (CRM_CONTACT_ID === null || CRM_CONTACT_ID === "") {
    return { isLoggedInUser: false, contactData: null };
  }
  const apimkey = import.meta.env.MAINSITE_REPORTS_API_KEY;
  const endPoint = `${
    import.meta.env.MAINSITE_WCC_APIM_BASE_URL +
    "/wcc-dynamics/contacts(" +
    CRM_CONTACT_ID +
    ")"
  }`;
  try {
    const response: Response = await fetchWithToken(endPoint, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        "wcc-apim-subscription-key": apimkey,
      },
    });
    const contactData = (await response.json()) as ContactData;
    return {
      isLoggedInUser: true,
      contactData,
    };
  } catch (err) {
    throw new Error(err as string);
  }
};

export const useUserData = (session: Storage) => {
  const crmId = session.getItem("crmId");
  const { data, error, isError, isLoading, isFetching } = useQuery(
    ["userDetails", crmId],
    async () => await fetchUserDetails(crmId ?? ""),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    },
  );
  return {
    ...data,
    error,
    isError,
    isLoading,
    isFetching,
  };
};
